enum BiteLogEigenEvent {
  /** @deprecated This event is not made as of 2025-06-02, Keep until 9/2 for parsing purposes */
  PaymentDeprecated = 1,
  TerminalDisconnected = 5,
}

export { BiteLogEigenEvent };
